var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics-card font-weight-light",style:(`
    background-color: ${_vm.background_color};
    color: ${_vm.background_color?'black':''};
    border-color: ${_vm.background_color}
    `)},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }